export default __webpack_public_path__ + "static/camera-10b2e7ef23fdb39c428458ca51a402c5.svg";